import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Transportista } from '../models/usuario';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransportistasService {
  private url = 'transportistas';
  constructor(
    private http: HttpClient,
    public afs: AngularFirestore) { }

  actualizarTransportista(transportista: Transportista) {
    const ref = this.afs.collection<Transportista>(this.url);
    return ref.doc(transportista.idFirebase).update(Object.assign({}, transportista));
  }

  obtenerTransportista(idTransportista: string) {
    const ref = this.afs.collection<Transportista>(this.url);
    return ref.doc(idTransportista).valueChanges();
  }

  async actualizarLicenciaTransportista(idTransportista: string, urlFoto: string) {
    const refTransportista = this.afs.collection(this.url).doc(idTransportista);
    try {
      await refTransportista.set({ fotoLic: urlFoto }, { merge: true });
      console.log(`Se actualizo foto de licencia ${urlFoto}`);
      console.log('La foto de licencia del transportista ha sido actualizada');
    } catch (err) {
      console.error(`Ha ocurrido un error, no hemos podido actualizar la foto de licencia \n ${err}`);
    }
  }


  /**
   * API
   */

  obtenerTransportistaADR(idTransportista: string) {
    return this.http
      .get(`${environment.ipApiBackend}/shipments/obtener-rutas?id_transportista=${{ idTransportista }}`)
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      console.error('Ha ocurrido un error:', error.error);
    } else {
      console.error(
        `Backend retorno error ${error.status}, Descripción: `, error.error);
    }
    return throwError(
      'Algo ha ocurrido; Por favor intenta más tarde.');
  }

}
